//#region src/location_preset_tip_type.ts
const LocationPresetTipType = {
	Percentage: "percentage",
	Fixed: "fixed"
};
//#endregion
export { LocationPresetTipType };

//# sourceMappingURL=location_preset_tip_type.js.map